import type {ReactNode} from 'react';
import styles from "../../Layout/Layout.module.css";

interface PageCardProps {
    title: string;
    children: ReactNode;
}

export default function PageCard({ title, children }: PageCardProps) {
    return (
        <div className={styles.main}>
            <h3>{title}</h3>
            <div className="card-content">{children}</div>
        </div>
    );
}